import util from '../util'

let controller = 'Cedentes'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
  GetByConta: function (dto) {
    return util.Axios.Get(`${controller}/GetByConta`, dto)
  },
  Combo: function (mostrarInativos) {
    return util.Axios.GetProperty(`${controller}/Combo`, mostrarInativos)
  },
  ComboPorBancoAgencia: function (codBanco, codAgencia, cedente, mostrarInativos) {
    const params = {
      CodigoBanco: codBanco,
      CodigoAgencia: codAgencia,
      MostrarInativos: mostrarInativos,
      Cedente: cedente
    }
    return util.Axios.Post(`${controller}/ComboPorBancoAgencia`, params)
  },
  Reprocessar: function (id) {
    return util.Axios.Put(`${controller}/Reprocessar`, id)
  },
  GetAll: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  }
})
